import { SectionHead } from "./SectionHead";

const PILLARS = [
  ["Leadership", "The opening keynote, The Conversation and the closing keynote — how leaders decide, fund and govern AI."],
  ["Frontier", "The Frontier Keynote and The Adoption Room — what the models can do now, and what boards should do about it."],
  ["Rules", "The Rules Segment and The Board Briefing — liability, governance and the EU AI Act as it reaches Norway."],
  ["Build", "One real business problem turned into working software, live on the main stage — and The Build Lab for the whole room."],
];

const DAY = [
  ["09:00", "Arrival"], ["09:30", "Opening keynote", true], ["10:20", "The Conversation"], ["11:30", "Frontier Keynote"],
  ["12:00", "Rules Segment"], ["13:00", "AI Experience · lunch"], ["14:30", "Live build"], ["16:00", "Closing keynote"], ["18:30", "Summit Dinner"],
];

export const TheDay = () => (
  <section className="ns-sec pp" id="programme" data-testid="ns-day">
    <div className="ns-wrap">
      <SectionHead nr="04" label="The programme" right="Proposed · one room, one programme" />
      <div className="ns-grid">
        <div className="g-1-7">
          <h2 className="ns-h2" data-rv data-testid="ns-day-h"><i>One designed day.</i><i>Four programme pillars.</i></h2>
        </div>
        <div className="g-8-12">
          <p className="ns-lede" data-rv style={{ "--d": ".1s" }} data-testid="ns-day-lede">
            The programme is being built now. Every session is prepared, briefed and moderated by the summit — no sales pitches on stage. Names follow when they are confirmed, not before.
          </p>
        </div>
        <div className="g-1-12">
          <ol className="ns-ledger" data-rv data-testid="ns-pillars">
            {PILLARS.map(([t, d], i) => (
              <li key={t}><span className="k">0{i + 1}</span><span className="t">{t}</span><span className="d">{d}</span></li>
            ))}
          </ol>
        </div>
      </div>
      <ol className="ns-tl" data-rv data-testid="ns-timeline">
        {DAY.map(([t, l, hi]) => (
          <li key={t} className={hi ? "hi" : ""}><span className="t">{t}</span><i className="pt" /><span className="l">{l}</span></li>
        ))}
      </ol>
      <p className="ns-tl-foot" data-rv data-testid="ns-day-foot">
        Proposed shape of the day. Highlighted: the opening session, when the whole room is in the same seat. Times are set with the programme; speakers are announced from autumn 2026.
      </p>
    </div>
  </section>
);
